import { ReactElement } from 'react';
import { Stack, StackProps, styled } from '@mui/material';

const StyledStack = styled(Stack)(({ theme }) => ({
    position: 'absolute',
    minHeight: 28,
    boxSizing: 'border-box',
    top: theme.spacing(2.5),
    right: theme.spacing(2.5),
}));

export const PoolCardQuickActions = (props: StackProps): ReactElement => (
    <StyledStack spacing={1} direction="row" alignItems="center" justifyContent="flex-end" {...props} />
);
